export const getHighlightedClassName = (highlightType) => {
   let className = 'highlighted';
   if (highlightType && highlightType !== true) {
      className += `-${highlightType}`;
   }
   return className;
};
